export default "__VITE_PUBLIC_ASSET__9c052581__"